export const themeSelectorStoreFeatures = {};